import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  sort: 'default',
  filter: 'all',
};


const filterSlice = createSlice({

  name: "filter",
  initialState,
  reducers: {
    filterChange: (state, action) => {
        state.filter = action.payload;
    },
    sortChange: (state, action) => {
        state.sort = action.payload;
    }
  },
});

export default filterSlice.reducer;
export const { filterChange, sortChange } = filterSlice.actions;